import {observer} from "mobx-react"
import React from "react";
import {serialize} from "serializr";
import {WidgetProps} from "controls/designer/features/widgets/widgetProps";
import {DefaultWidgetWrapper} from "controls/designer/features/widgets/defaultWidgetWrapper";
import {Toolbar} from "controls/react/layout/toolbar";
import {Section} from "controls/react/layout/section";
import {Grid} from "controls/grid/grid";
import {TimePeriodAppearance, TimePeriodSelector} from "controls/react/form/timePeriodSelector";
import {DataSizeIndicator} from "controls/grid/dataSizeIndicator";
import {GridSearchInput} from "controls/grid/gridSearchInput";
import {ViewSelector} from "controls/grid/viewManager/viewSelector";
import {TimePeriodType} from "controls/react/form/timePeriodType";
import {anyFlagSet} from "areas/service-boards/widgets/grids/gridToolbarVisibility";
import {BoxView} from "controls/react/layout/boxView";

import {DataSourceDataGridWidgetStore} from "./store";
import {DataSourceDataGridWidgetPersistedState, DataSourceDataGridWidgetConfig} from "./types";


const TimePeriods = [TimePeriodType.Last24Hours, TimePeriodType.Last7Days,
	TimePeriodType.Last30Days, TimePeriodType.Custom, TimePeriodType.DynamicInterval, TimePeriodType.All, TimePeriodType.LastN];

export const DataSourceDataGridWidget = observer(
	class InnerWidget extends React.Component<WidgetProps<DataSourceDataGridWidgetConfig, DataSourceDataGridWidgetPersistedState>>{
		store: DataSourceDataGridWidgetStore
		get viewMode() {
			return this.props.designer.config.chromeless
		}

		constructor(props: WidgetProps<DataSourceDataGridWidgetConfig, DataSourceDataGridWidgetPersistedState>) {
			super(props)

			this.store = new DataSourceDataGridWidgetStore(props)
		}

		async componentDidMount() {
			await this.store.init()
		}

		render() {
			const gridStore = this.store.dataSourceDataGridStore?.gridStore

			const editMode = !this.props.designer.config.chromeless
			const flags = this.props.config.gridToolbarVisibility

			return (
				<DefaultWidgetWrapper {...this.props}>
					{this.store.errorMessage && <BoxView type={'error'}>{this.store.errorMessage}</BoxView>}
					{gridStore && <Section appearance="none" height={"fit"}>
						{(anyFlagSet(flags) || this.store.showTimePeriodSelector || editMode) &&
							<Toolbar>
								{this.store.showTimePeriodSelector && <TimePeriodSelector periods={TimePeriods}
																						  appearance={TimePeriodAppearance.Buttons}
																						  size={"small"}
																						  value={this.store.timePeriod}
																						  onChange={this.store.onPeriodChange}/>}

								{(flags.showFilters || editMode) && <DataSizeIndicator store={gridStore}/>}

								{(flags.showFilters || editMode) && <GridSearchInput store={gridStore}/>}

								{(flags.showViewSelector || editMode) &&
									<ViewSelector store={gridStore} createViewDisabled={this.viewMode}
												  editViewDisabled={this.viewMode}/>}
							</Toolbar>
						}
						<Grid store={gridStore}/>
					</Section>}
				</DefaultWidgetWrapper>
			)
		}

		getStateForSaving() {
			if (!this.store.dataSourceDataGridStore.gridStore) {
				return {}
			}

			return {
				grid: serialize(this.store.dataSourceDataGridStore.gridStore?.state)
			};
		}

		componentWillUnmount(){
			this.store?.destroy()
		}
	}
)

export type {DataSourceDataGridWidgetConfig, DataSourceDataGridWidgetPersistedState};
